module.exports = __webpack_public_path__ + "static/media/nosotros.765d7611.jpg";